export default {

  template: /* html */`
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="100"
    height="100"
    viewBox="0 0 26.458333 26.458333"
    version="1.1"
    id="svg2707"
    inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)"
    sodipodi:docname="pentagon.svg">
    <defs
      id="defs2701" />
    <sodipodi:namedview
      id="base"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0.0"
      inkscape:pageshadow="2"
      inkscape:zoom="3.1579063"
      inkscape:cx="116.25311"
      inkscape:cy="64.551163"
      inkscape:document-units="px"
      inkscape:current-layer="layer1"
      showgrid="false"
      units="px"
      inkscape:window-width="1920"
      inkscape:window-height="987"
      inkscape:window-x="0"
      inkscape:window-y="0"
      inkscape:window-maximized="1" />
    <metadata
      id="metadata2704">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(0,-270.54167)">
      <path
        sodipodi:type="star"
        id="path816"
        sodipodi:sides="5"
        sodipodi:cx="17.259588"
        sodipodi:cy="285.52155"
        sodipodi:r1="12.031453"
        sodipodi:r2="6.0157266"
        sodipodi:arg1="0.64210835"
        sodipodi:arg2="1.2704269"
        inkscape:flatsided="true"
        inkscape:rounded="0"
        inkscape:randomized="0"
        d="m 26.894796,292.727 -13.510564,4.18478 -8.154953,-11.55614 8.470526,-11.32687 13.390025,4.55576 z"
        transform="matrix(0,1.0996531,-1.1510858,0,341.82995,266.00093)" />
    </g>
  </svg>

  `
}